import { Component, OnInit, AfterViewInit, ViewChild, Input, HostListener, SimpleChanges, ElementRef, OnChanges } from '@angular/core';
import Swiper from 'swiper';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-homebannercarousel',
  templateUrl: './homebannercarousel.component.html',
  styleUrls: ['./homebannercarousel.component.scss']
})
// export class HomebannercarouselComponent implements AfterViewInit {
//   @Input() item: any;
//   @Input() img: any;
//   public serverPath = environment.commonImageApi + '/home/';
//   public bannerServerPath = environment.commonImageApi + '/commonSlider/';

//   @ViewChild('swiper', { static: true }) swiperContainer: any;
//   dynamicSlides:any;

//   constructor(
    
//   ) {
//     this.dynamicSlides = [
//       { id: 1, src:'https://www.lemontreehotels.com/Ka_assest/images/LemonTreeHotelHaridwar.jpg', alt:'Side 1', title:'LEMON TREE HOTEL, CHENNAI' },
//       { id: 2, src:'https://www.lemontreehotels.com/Images/slider/Kasauli-Facade-Evening.jpg', alt:'Side 2', title:'LEMON TREE HOTEL, CHENNAI' },
//       { id: 3, src:'https://www.lemontreehotels.com/Images/slider/facade-malad.jpg', alt:'Side 3', title:'LEMON TREE HOTEL, CHENNAI' },
//       { id: 4, src:'https://www.lemontreehotels.com/Images/slider/Kasauli-Facade-Evening.jpg', alt:'Side 4', title:'LEMON TREE HOTEL, CHENNAI' },
//       { id: 5, src:'https://via.placeholder.com/600/f66b97', alt:'Side 5', title:'LEMON TREE HOTEL, CHENNAI' },
//       { id: 6, src:'https://www.lemontreehotels.com/Ka_assest/images/LemonTreeHotelHaridwar.jpg', alt:'Side 1', title:'LEMON TREE HOTEL, Mumabi' },
//       { id: 7, src:'https://picsum.photos/400/300.jpg', alt:'Side 5', title:'LEMON TREE HOTEL, CHENNAI' },
//     ];
  
//   }

//   ngAfterViewInit() {
//      const isMobile = window.innerWidth <= 768;
//   new Swiper(this.swiperContainer.nativeElement, {
//     effect: 'slide',
//     slidesPerView: 'auto',
//     spaceBetween: isMobile ? 5 : -40,
//     centeredSlides: true,
//     loop: true,
//     grabCursor: true,
//     slideActiveClass: 'swiper-slide-active',
//     slidePrevClass: 'swiper-slide-prev',
//     slideNextClass: 'swiper-slide-next'
//   });
//   }


//   openlink(url: string) {
//     console.log(url);
//     if (url) {
//       const fullURL = this.prependProtocol(url);
//       window.open(fullURL, '_blank');


//     }
//   }
  
//   prependProtocol(url: string): string {
//     if (!url.includes('http://') && !url.includes('https://')) {
//       return 'https://' + url;
//     }
//     return url;
//   }



// }
export class HomebannercarouselComponent implements AfterViewInit, OnChanges {
  @Input() item: any;
  @Input() img: any[] = [];

  public serverPath = environment.commonImageApi + '/home/';
  public bannerServerPath = environment.commonImageApi + '/commonSlider/';
  screenWidth: number = window.innerWidth;

  filteredImages: any[] = [];
  swiperInstance: any;

  @ViewChild('swiper', { static: true }) swiperContainer!: ElementRef;

  constructor() {
    this.updateScreenWidth();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['img'] && this.img?.length) {
      this.filterImagesByDevice();
      this.initSwiper();
    }
  }

  ngAfterViewInit() {
    this.filterImagesByDevice();
    this.initSwiper();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = event.target.innerWidth;
    this.filterImagesByDevice();
    this.initSwiper();
  }

  updateScreenWidth() {
    this.screenWidth = window.innerWidth;
  }

  filterImagesByDevice() {
    const isMobile = this.screenWidth <= 767;
    const isTab = this.screenWidth > 767 && this.screenWidth <= 1024;
    const isWeb = this.screenWidth > 1024;

    this.filteredImages = (this.img || []).filter((brand: any) => {
      switch (brand.customField22) {
        case '1': return true;       // All devices
        case '2': return isMobile;   // Mobile only
        case '3': return isTab;      // Tablet only
        case '4': return isWeb;      // Web only
        default: return true;
      }
    });
  }

  initSwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
    }

    const isMobile = this.screenWidth <= 768;

    this.swiperInstance = new Swiper(this.swiperContainer.nativeElement, {
      effect: 'slide',
      slidesPerView: 'auto',
      spaceBetween: isMobile ? 5 : -40,
      centeredSlides: true,
      loop: true,
      grabCursor: true,
      slideActiveClass: 'swiper-slide-active',
      slidePrevClass: 'swiper-slide-prev',
      slideNextClass: 'swiper-slide-next'
    });
  }

  openlink(url: string) {
    if (url) {
      const fullURL = this.prependProtocol(url);
      window.open(fullURL, '_blank');
    }
  }

  prependProtocol(url: string): string {
    if (!url.includes('http://') && !url.includes('https://')) {
      return 'https://' + url;
    }
    return url;
  }
}


